define('ajax',['lib/es6-promise'], function(promise) {
	function send(params) {
		var xhr = new XMLHttpRequest();
		var isDone = false;
		var rejectCallback;
		var result = {
			xhr: xhr,
			abort: function() {
				if (isDone) {
					return;
				}
				xhr.onreadystatechange = null;
				var error = new Error('Der Vorgang wurde abgebrochen.');
				error.isAbort = true;
				isDone = true;
				rejectCallback(error);
			}
		};
		result.finished = new promise.Promise(function(resolve, reject) {
			rejectCallback = reject;
			xhr.open(params.method, params.url);
			xhr.setRequestHeader('Accept', 'application/json');
			xhr.onreadystatechange = function(e) {
				if (xhr.readyState != 4)
					return;

				isDone = true;

				if (xhr.status == 413) { // too long entity
					reject('Die hochgeladene Datei ist zu groß.');
				} else if (xhr.status >= 400 && xhr.status < 500) {
					try {
						var json = JSON.parse(xhr.responseText);
						if (typeof(json.error) == 'string')
							reject(new Error(json.error));
					} catch(e) {
						reject(e);
					}
				} else if (xhr.status < 200 || xhr.status >= 300) {
					reject();
				} else {
					try {
						var json = JSON.parse(xhr.responseText);
						resolve(json);
					} catch (e) {
						return reject(e);
					}
				}
			};
			xhr.send(params.data);
		});
		return result;
	}

	return {
		send: send,
		post: function(url, data) {
			if (typeof data == 'object' && !(data instanceof FormData)) {
				var fd = new FormData();
				for (var key in data) {
					if (!data.hasOwnProperty(key))
						continue;
					fd.append(key, data[key]);
				}
				data = fd;
			}
			return send({
				method: 'POST',
				url: url,
				data: data
			});
		},
		get: function(url, data) {
			for (var key in data) {
				if (!data.hasOwnProperty(key))
					continue;
				if (url.indexOf('?') >= 0)
					url += '&';
				else
					url += '?';
				var value = data[key];
				url += encodeURIComponent(key) + '=' + encodeURIComponent(value);
			}
			return send({
				method: 'GET',
				url: url,
			});
		},
	}
});

